import { Skull, Flame } from "lucide-react";

export const Marquee = ({ text }) => {
  const items = new Array(2).fill(text);
  return (
    <div
      className="relative overflow-hidden bg-acid py-3 border-y-2 border-black"
      data-testid="editorial-marquee"
    >
      <div className="flex w-max animate-marquee">
        {items.map((t, i) => (
          <span key={i} className="flex items-center gap-4 px-4 whitespace-nowrap">
            <Skull size={14} className="text-black shrink-0" strokeWidth={2} />
            <span className="font-mono font-extrabold uppercase tracking-[0.2em] text-xs sm:text-sm text-black">
              {t}
            </span>
            <Flame size={14} className="text-black shrink-0" strokeWidth={2} />
          </span>
        ))}
      </div>
    </div>
  );
};
